import axiosClient from "../../../../api/axiosClient";

// ==============================
// ORDER APIs
// ==============================

// CREATE ORDER
export const createOrder = (payload) => {
  return axiosClient.post("/api/ipe/orders", payload);
};

// GET ORDER LIST
export const getOrders = (filters = {}) => {
  return axiosClient.get("/api/ipe/orders", {
    params: filters
  });
};

// SUBMIT ORDER
export const submitOrder = (id) => {
  return axiosClient.post(`/api/ipe/orders/${id}/submit`);
};

// APPROVE ORDER
export const approveOrder = (id) => {
  return axiosClient.post(`/api/ipe/orders/${id}/approve`);
};

// ==============================
// MASTER / LOOKUP APIs
// ==============================

// BUSINESS PARTNER (CUSTOMER)
export const getCustomers = () =>
  axiosClient.get("/api/ppe/masters/business-partner");

// ENQUIRY LIST
export const getEnquiries = () =>
  axiosClient.get("/api/ipe/enquiries");

// 🔥 ENQUIRY ITEMS (IMPORTANT - USED FOR ORDER ITEMS)
export const getEnquiryItems = (enquiry_id) =>
  axiosClient.get(`/api/ipe/enquiries/${enquiry_id}/items`);

// ==============================
// QUOTATION APIs
// ==============================

// GET QUOTATION BY ENQUIRY
export const getQuotations = (enquiry_id) =>
  axiosClient.get(`/api/ipe/selling-quotation/enquiry/${enquiry_id}`);

// GET QUOTATION DETAIL (SAME API - KEPT FOR CLARITY)
export const getQuotationDetail = (enquiry_id) =>
  axiosClient.get(`/api/ipe/selling-quotation/enquiry/${enquiry_id}`);

export const getSellingCost = (enquiry_id) =>
  axiosClient.get(`/api/ipe/selling-cost/enquiry/${enquiry_id}`);

export const getOrderById = (id) => {
  return axiosClient.get(`/api/ipe/orders/${id}`);
};

// ==============================
// PAYMENT UPDATE API
// ==============================
export const updatePayment = (payload) => {
  return axiosClient.post("/api/ipe/orders/payment/update", payload);
};

export const updateOrder = (id, payload) => {
  return axiosClient.put(`/api/ipe/orders/${id}`, payload);
};